import React from 'react'
import Navbar from '../inc/Navbar'
import Restaurant from './Restaurant'

function Restaurantpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>

        <br/>
        <br/>
        <Restaurant/>
        <br/>
    </div>
  )
}

export default Restaurantpage